import BooksContainer from '../components/BooksContainer';
import Header from '../components/Header';

const Home = () => (
  <>
    <Header />
    <BooksContainer />
  </>
);

export default Home;
